// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","careers-carousel":"careersCarousel-module__careers-carousel___1W56I","careersCarousel":"careersCarousel-module__careers-carousel___1W56I"};